/* eslint-disable max-len */
// disable max-len due to long SVG paths

// eslint-disable-next-line import/no-extraneous-dependencies
import { toast } from 'react-toastify';
import { Icon } from '@nespresso-design-system/components';
import NotificationText from '../NotificationText/NotificationText.tsx';
import type { NotificationType } from '../types';

export function notify(type: NotificationType, text: string) {
  const backgroundColor = `var(--toastify-bg-${type})`;

  let icon = null;

  // based on https://storybook.nespresso.com/icons/
  const commonPropsForIcons = {
    width: 20,
    height: 20,
    method: 'image' as 'image'
  };

  // eslint-disable-next-line default-case
  switch (type) {
    case 'success': {
      icon = <Icon icon="24/symbol/status-success" {...commonPropsForIcons} />;
      break;
    }

    case 'warning': {
      icon = <Icon icon="32/symbol/status-alert" {...commonPropsForIcons} />;
      break;
    }

    case 'error': {
      icon = <Icon icon="32/symbol/status-error" {...commonPropsForIcons} />;
      break;
    }

    case 'info': {
      icon = <Icon icon="32/symbol/information" {...commonPropsForIcons} />;
      break;
    }
  }

  toast[type](<NotificationText type={type} text={text} />, {
    autoClose: 7000,
    hideProgressBar: true,
    style: {
      backgroundColor
    },
    icon,
    closeOnClick: true,
    closeButton: (
      <Icon
        icon="24/symbol/x"
        {...commonPropsForIcons}
        width={18}
        height={18}
      />
    )
  });
}
